<div class="help-txt" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start stretch">
	<mat-icon class="aside-icon">information</mat-icon>

	<div [innerHtml]="locale.translate('resource_help_text')">

	</div>


</div>
